import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Avatar } from '@material-ui/core';

import BOOKING_STATUS from '../../constants/employeeBookingStatus';

import '../../assets/stylesheets/ScheduleView.css';

import {studioBookingTimeSymbol} from '../../constants/general';

class EmployeeChip extends Component {
  getChipStyle = () => {
    const { isSelected, status } = this.props;

    if (isSelected) return 'employeeChipSelected';

    switch (status) {
      case BOOKING_STATUS.EMAIL_SENT:
        return 'employeeChipEmailSent';
      case BOOKING_STATUS.CANCELED:
        return 'employeeChipCanceled';
      case BOOKING_STATUS.DECLINED:
        return 'employeeChipDeclined';
      case BOOKING_STATUS.EMAIL_CONFIRMED:
        return 'employeeChipConfirmed';
      case BOOKING_STATUS.UNBOOKED_FREELANCER:
        return 'employeeChipUnbookedFreelancer';
      default:
        return '';
    }
  };

  onClick = () => {
    const {
      positionId,
      locationId,
      bookedDate,
      employeeId,
      onEmployeeSelect
    } = this.props;
    onEmployeeSelect(positionId, locationId, bookedDate, employeeId);
  };

  render() {
    const { employeeName, profileImage, availabilityType } = this.props;
    const chipDisplayText = `${employeeName} ${studioBookingTimeSymbol[availabilityType]}`;

    return (
      <div
        role='button'
        onKeyPress={this.onClick}
        className={`employeeChip ${this.getChipStyle()}`}
        onClick={this.onClick}
        tabIndex={0}
      >
        <Avatar
          className="employeeChipAvatar"
          alt={employeeName}
          src={profileImage}
        />
        <p>{chipDisplayText}</p>
      </div>
    );
  }
}

EmployeeChip.propTypes = {
  positionId: PropTypes.number.isRequired,
  locationId: PropTypes.number.isRequired,
  bookedDate: PropTypes.string.isRequired,
  employeeId: PropTypes.number.isRequired,
  employeeName: PropTypes.string.isRequired,
  profileImage: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  status: PropTypes.number.isRequired,
  onEmployeeSelect: PropTypes.func.isRequired,
  availabilityType: PropTypes.string.isRequired
};

export default EmployeeChip;
